// Mock data for TapTrack clone

export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/14AbJ11G229e6AodVnbII02"; 

export const SITE = {
  logo: "/images/taptrack-rev2.png",
  tagline: "Draw in and engage your users with the power of contactless technology.",
  email: "contact@taptrack.com",
  location: "Proudly Based in Toronto",
};

export const NAV = {
  services: [
    { label: "NFC Consulting", href: "/nfc-consulting" },
    { label: "Solution Development", href: "/nfc-consulting" },
    { label: "Workshops", href: "/workshops" },
  ],
  resources: [
    { label: "Tag 101", href: "/tag-101" },
    { label: "Development Kits", href: "/development-kits" },
    { label: "White Papers", href: "/white-papers" },
  ],
  company: [
    { label: "Blog", href: "/blog" },
    { label: "Contact Us", href: "/contact-us" },
  ],
};

export const SERVICES = [
  {
    title: "NFC Consulting",
    desc: "TapTrack is a one-stop shop for all things NFC. We can provide everything from personalized tags to custom reader and application development. Interested in seeing how we can help you add NFC to your business?",
    cta: "See How",
    href: "/nfc-consulting",
    icon: "sparkles",
  },
  {
    title: "Cashless Solutions",
    desc: "Grow your business with the power of closed-loop cashless technology. Increase the speed, efficiency, transparency of your operations without the need for on-site support or reliable internet coverage. Now available with a full point of sale.",
    cta: "Learn More",
    href: "https://mywristcoin.com/",
    external: true,
    icon: "credit-card",
  },
  {
    title: "The Tappy",
    desc: "Previously used solely for applications developed by TapTrack, we are now making the Tappy available to the general public. Proudly made in Canada and available in both USB and BLE variants, the Tappy provides a powerful abstraction from low-level NFC operations to allow fast-paced NFC development.",
    cta: "Shop Now",
    href: "/shop",
    icon: "cpu",
  },
];

export const PARTNERS = [
  "/images/partners/partner-1.png",
  "/images/partners/partner-2.png",
  "/images/partners/partner-3.png",
  "/images/partners/partner-4.png",
  "/images/partners/partner-5.png",
  "/images/partners/partner-6.png",
  "/images/partners/partner-7.png",
  "/images/partners/partner-8.png",
  "/images/partners/partner-9.png",
  "/images/partners/partner-10.png",
  "/images/partners/partner-11.png",
];

export const HERO_BG = "/images/hero-bg.jpg";

export const PRODUCTS = [
  {
    id: "tappyusb",
    slug: "tappyusb-all-in-one-nfc-reader-writer-and-emulator",
    name: "TappyUSB \u2013 All-in-One NFC Reader, Writer, and Emulator",
    price: 149.99,
    sku: "05-703",
    category: "Tappy",
    images: [
      "/images/products/tappyusb1-700x700.png",
      "/images/products/tappyusb-exposure-700x700.png",
      "/images/products/tappyusb-side-dark-700x700.png",
    ],
    thumb: "/images/products/tappyusb-exposure-500x500.png",
    hoverThumb: "/images/products/tappyusb1-500x500.png",
    shortDesc: "The TappyUSB is an enterprise-grade, all-in-one NFC encoder that is easily integrated into your NFC solutions and applications.",
    datasheet: "https://drive.google.com/file/d/1I9lgDHy8orQhnrbRjQZcGvi2QnjxRxIq/view?usp=sharing",
    features: [
      "Read and write to the most popular NFC chips (ISO 14443 A/B, Tag Types 1,2,3, and 4.)",
      "Focus on writing your own software application, not figuring out NFC code libraries. The Tappy includes a full NFC software stack.",
      "Built in NDEF reading/writing/emulation for superior scanning speed and smoother user experience",
      "Full software support. Includes a free open source SDK and example code for Android, iOS, Windows, JavaScript.",
      "Total technical support from TapTrack, the engineers who created Tappy.",
      "Security. Cryptography libraries including AES, TDES, SHA1, SHA2, and PBKDF2 all on board.",
      "Enumerates as serial COM port over USB w/ plug & play Window/Mac/Linux driver",
      "Connected over USB, but capable of operating standalone (checkin station mode)",
    ],
    specs: [
      ["Supported Standards", "ISO/IEC 14443A, 14443B, 18092, ECMA 340 Peer-to-Peer"],
      ["Supported Chips", "NFC Forum Type 1: Topaz, Jewel; Type 2: NTAG 20x, 21x, MIFARE Ultralight; Type 4: DESFire EV1 2K/4K/8K; MIFARE Classic 1K, 4K"],
      ["Frequency", "13.56 MHz"],
      ["Max RF Output Power", "<0.5W"],
      ["RF Communication Speed", "106, 212, 424 kbits/s"],
      ["Current", "<100 mA"],
      ["Read Range", "40mm typical, 100mm max"],
      ["Working Temperature", "-10\u00b0C to +70\u00b0C"],
      ["Storage Temperature", "-30\u00b0C to +80\u00b0C"],
      ["Enclosure Dimensions", "L = 12.5cm; W = 8cm; H = 3cm"],
      ["Weight", "0.17 kg"],
    ],
  },
];
